export function readQuantityBound(value: string | null | undefined): number | null {
  if (value == null || value.trim() === "") return null;
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : null;
}

export function clampOrderQuantity(
  quantity: number,
  min: number | null,
  max: number | null,
): number {
  if (!Number.isFinite(quantity)) return quantity;
  let next = quantity;
  if (min != null && min > 0 && next < min) next = min;
  if (max != null && max > 0 && next > max) next = max;
  return next;
}
